import { useQuery } from '@tanstack/react-query';

import { CabinEventClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const cabinEventClient = new CabinEventClient(apiBaseUrl);

function useGetCabinEventSubmissions() {
  return useQuery({
    queryKey: [queryKeys.CabinEvent.Submissions],
    queryFn: () => cabinEventClient.getSubmissions(),
  });
}

export default useGetCabinEventSubmissions;
